import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'

import { Icons } from './Icons'
import LockIcon from '../assets/icons/candado.svg'

export const CardInfoShorts = (props) => {
  const { vod, isHome, pay, isUnlocked, showSeason, useImageCDN, isShort, isPlayingShort, isGridMode, preferredPlan } = props

  let link

  switch (vod.type) {
    case 'Vod':
      if (isShort) {
        link = `/player/shorts/${vod._id}`
      } else {
        link = `/player/vod/${vod._id}`
      }
      break;
    default:
      link = `/player/vod/${vod._id}`
      break;
  }

  return (
    <Link
      to={
        !isUnlocked && pay
          ? {
            pathname: '/planes',
            search: preferredPlan ? `?preferredPlan=${preferredPlan}` : ''
          }
          : link
      }
    >
      <article
        className={classNames({
          'articleItemBox whitVisibleTitle': true,
          'cwCard': isHome,
          'isPlaying': isPlayingShort,
          'isViewed': vod.isViewed
        })}
      >
        <figure className='ratioImgBox ratioThumb'>
          {!isUnlocked && pay && <Icons path={LockIcon} className='lockIcon' />}
          {isPlayingShort && !isGridMode &&
            <div className='bounceSignalIcon'>
              <div className='bounceBar a'></div>
              <div className='bounceBar b'></div>
              <div className='bounceBar c'></div>
            </div>
          }
          <img
            src={!isEmpty(vod.imagesSite.thumbnail)
              ? useImageCDN
                ? vod.imagesSite.thumbnail.replace('https://api-megago.megamedia.cl', 'https://megago.cdn.mdstrm.com')
                : vod.imagesSite.thumbnail
              : 'https://images2-mega.cdn.mdstrm.com/ott/placeholders-imgs/placeholder-thumbnail.jpg'
            }
            alt=''
          />
        </figure>
        {isGridMode ?
          isPlayingShort ?
            <header>
              <div className='bounceSignalIcon'>
                <div className='bounceBar a'></div>
                <div className='bounceBar b'></div>
                <div className='bounceBar c'></div>
              </div>
            </header>
            :
            <header>
              <h3>{
                vod.serie?.seasons.length > 0 &&
                `${showSeason ? `T${vod.season?.order || 1}:` : ''}${Number(vod.order) + 1}`
              }
              </h3>
            </header>
          :
          <header>
            <div>
              <h3>
                <span>{
                  vod.serie?.seasons.length > 0 &&
                  `${showSeason ? `T${vod.season?.order || 1}:` : ''}E${Number(vod.order) + 1}`
                }</span>
                {vod.serie?.seasons.length > 0 && vod.title}
              </h3>
              <p>
              </p>
            </div>
            <div className='continueBar' style={{ 'width': '100%', 'display': vod.position ? 'block' : 'none' }}>
              <span style={{
                'width': `${(isNaN((vod.position / vod.duration)) ? 0 : (vod.position / vod.duration) * 100)}%`
              }} />
            </div>
          </header>
        }
      </article>
    </Link>
  )
}